﻿import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TimePicker } from "@blueprintjs/datetime";
import { FormHelperText } from "components/form-fields";
import classNames from "classnames";
import moment from "moment";
import 'components/form-fields/FormFields.css';
import "moment/locale/en-gb";
import { ShowHide } from "components/layout";

const dateLocale = "en-gb";

export function FormTimePicker(
    {
        id = null,
        value = null,
        disabled = false,
        loading = false,
        minTime = null,
        maxTime = null,
        headingText = null,
        dangerHelperText = "",
        helperText = "",
        showArrowButtons = true,
        useAmPm = false,
        onChange
    }
) {
    const [valueValue, setValue] = useState(null);
    const minTimeDefault = moment().startOf('day').toDate();
    const maxTimeDefault = moment().endOf('day').toDate();
    const [minTimeValue, setMinTime] = useState(minTimeDefault);
    const [maxTimeValue, setMaxTime] = useState(maxTimeDefault);

    useEffect(() => {
        var newValue = null;

        if (value) {
            newValue = moment.utc(value).locale(dateLocale).toDate();
        }

        setValue(newValue);

    }, [value]);

    function setMinTimeFromProps() {
        const newMinTime = minTime || minTimeDefault;
        setMinTime(newMinTime);
    }
    function setMaxTimeFromProps() {
        const newMaxTime = maxTime || maxTimeDefault;
        setMaxTime(newMaxTime);
    }

    function handleTimeChange(selectedDate) {        
        if (selectedDate === "") {
            selectedDate = null;
        }
        onChange(selectedDate);
    }

    useEffect(setMinTimeFromProps, [minTime]);
    useEffect(setMaxTimeFromProps, [maxTime]);

    return (
        <div className="form-field">
            <ShowHide
                evaluator={headingText != null}
                show={(
                    <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
                )}
            />
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <TimePicker
                disabled={disabled}
                className={classNames({ "bp6-skeleton": loading }, { "margin-up": showArrowButtons })}
                value={valueValue}
                onChange={handleTimeChange}
                minTime={minTimeValue}
                maxTime={maxTimeValue}
                showArrowButtons={showArrowButtons}
                useAmPm={useAmPm}
                selectAllOnFocus
            ></TimePicker>
            <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormTimePicker.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    minTime: PropTypes.instanceOf(Date),
    maxTime: PropTypes.instanceOf(Date),
    loading: PropTypes.bool,
    headingText: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    dangerHelperText: PropTypes.string,
    helperText: PropTypes.string,
    showArrowButtons: PropTypes.bool,
    useAmPm: PropTypes.bool
};